<template>
    <div id="content">
        <link rel="stylesheet" href="/themes/ito/css/parents.css">

        <div class="container">
            <div id="page-header-fixed" class="mb-25">
                <div class="container">
                    <div id="page-header">
                        <div class="buttons">
                            <UpgradeNavTabs />
                        </div>
                    </div>
                </div>
            </div>
            <div id="upgrade-detail" class="card card-comments" style="color: #000; font-size: 16px;">
                <div class="card-body" style="padding: 0;border-radius: 8px;">
                    <h5 class="card-title" style="background: #FFE39B;padding: 12px 30px; margin: 0;border-radius: 8px 8px 0px 0px;">
                        <span class="title">{{ $t('unlock_full_access') }}</span>
                    </h5>

                    <div class="card-content">
                        <template v-if="packages.length > 0">
                            <div v-if="step == 1">
                                <SimpleSwiper class="pb-3" :items="packages" :showNavigation="false" :showPagination="false" :loop="false" :autoplay="false" :slidesPerView="2" :slidesPerGroup="1" :spaceBetween="12" :breakpoints="{
                                    1024: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 16 },
                                }">
                                    <template #slide="{ item }">
                                        <input :id="`package_${item.id}`" name="package_select" type="radio" v-model="package_select" :value="item.id" />
                                        <label :for="`package_${item.id}`" class="d-flex flex-column payment-package-item" :class="package_select == item.id ? 'active' : ''">
                                            <div class="title">{{ item.name }}</div>
                                            <div class="flex-grow-1 desc-box">
                                                <div class="desc-box-item" v-for="desc in item.desc">
                                                    <img src="/themes/ito/images/icon-upgrade.svg" alt="" />
                                                    <span>{{ desc }}</span>
                                                </div>
                                            </div>
                                        </label>
                                    </template>
                                </SimpleSwiper>

                                <div class="col-md-12 text-center mt-3">
                                    <button class="btn btn-main" :class="{ 'disabled': packages.length === 0 }" style="padding: 8px 60px;" @click="gotoStep(2), handleSelect(package_select)">
                                        {{ $t('upgrade_account') }}
                                    </button>
                                </div>
                            </div>
                            <div v-if="step == 2">
                                <p class="label-upgrade">{{ $t('please_select_how_you_would_like_to_pay') }}</p>
                                <template v-for="(pkg) in packages">
                                    <div v-for="(item) in pkg.products" class="slect-product" v-bind:key="item.product_id">
                                        <input :id="'product_' + item.product_id" name="product_item" type="radio" v-model="product" :value="item.product_id" @input="itemProduct = item" />
                                        <label :for="'product_' + item.product_id" class="slect-group slect-package justify-content-between box-shadow-main" :class="item.package_id == package_select ? 'slect-show' : 'slect-hide'">
                                            <div>{{ item.product_name ? item.product_name : 'Product Name' }}</div>
                                            <div style="margin-top: 20px;">
                                                <p>{{ item.price | toCommas }} &#8363;</p>
                                                <p class="slect-name text-end text-decoration-line-through" v-if="item.original_price && item.original_price > item.price">{{ item.original_price | toCommas }} &#8363;</p>
                                            </div>
                                        </label>
                                    </div>
                                </template>
                                <p style="font-size:14px; margin-top:10px"><b>(*) {{ $t('note') }}:</b> {{ $t('desc_payment') }}</p>
                                <div class="col-md-12 mt-20 text-center">
                                    <div class="btn btn-back" @click="gotoStep(1)"> {{ $t('back') }}
                                    </div>
                                    <div class="btn btn-main" @click="product != '' ? gotoStep(3) : ''"> {{ $t('continue_txt') }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="step == 3">
                                <div style="display: flex;justify-content: space-between" class="label-upgrade">
                                    <div>{{ $t('package_selected') }}:
                                        <span style="font-weight: 600">{{ itemProduct.product_name }}</span>
                                    </div>
                                    <div class="slect-cost" style="font-weight: 600">{{ itemProduct.price | toCommas }} đ</div>
                                </div>
                                <!-- <p class="label-upgrade">{{ $t('lisa_web_add_a_promotion_code') }}</p>
                                <div class="d-flex align-items-center" style="margin-bottom: 12px">
                                    <input class="input-promotion" style="width:83%" :placeholder="$t('enter_the_promotion_code')" v-model="applyCode" />
                                    <div class="btn-promotion-code btn-apply_code btn" style="width:17%" :style="applyCode != '' ? 'background: #00A3FF;' : ''">{{ $t('apply_code') }}</div>
                                </div> -->
                                <p class="label-upgrade">{{ $t('please_select_how_you_would_like_to_pay') }}</p>
                                <div class="row row-cols-4 gap-3">
                                    <label class="col d-flex flex-column align-items-center payment-method-item box-shadow-main" :class="{ active: method === gate.method }" v-for="(gate, index) in gates"
                                        v-if="gate.method == 'momo' || gate.method == 'vnpay'" :key="index">
                                        <input name="radio-select" type="radio" v-model="method" :value="gate.method" v-bind:key="gate.method" />
                                        <div class="img-gate-box">
                                            <img :src="gate.icon">
                                        </div>
                                        <div class="payment-method-text p-2" v-html="gate.name"></div>
                                    </label>
                                </div>
                                <div class="col-md-12 mt-20 text-center">
                                    <button type="button" class="btn btn-back" @click="gotoStep(2)"> {{ $t('back') }}
                                    </button>
                                    <button type="button" class=" btn btn-main" @click="product != '' ? Payment() : ''" :disabled="method === ''">{{ $t("pay_now") }}
                                    </button>
                                </div>
                                <!--<div class="btn-payment box-shadow-main" data-dismiss="modal" data-toggle="modal"-->
                                <!--data-target="#PopupPayment">Pay now-->
                                <!--</div>-->
                            </div>
                        </template>
                        <template v-else>
                            <p class="text-center p-5">{{ $t('empty_data') }}</p>
                        </template>
                    </div>
                </div>
            </div>

            <div class="modal fade payment-popup" id="PopupPayment" tabindex="-1" role="dialog" aria-labelledby="PopupPayment" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 700px;">
                    <div class="modal-content box-shadow-main">
                        <div class="close-popup" data-dismiss="modal"></div>
                        <h3 class="popup-title mb-20">{{ $t("payment_confirmation") }}</h3>
                        <p><b>{{ $t("your_current_account_information") }}</b><br />
                            {{ $t("username") }} <b>demo_001</b><br />
                            {{ $t("current_package") }}: <b>iTO PLUS 12 months</b><br />
                            {{ $t("expired_date") }}: <b>19 May, 2022</b><br /><br />
                            {{ $t("you_are_buying_a_package") }} <b>iTO PRO 1 months.</b><br />
                            {{ $t("if_you_agree_to_pay_the_new_package_will_replace_the") }} <b>iTO PLUS 12 months</b> {{ $t("package_is_still_in_effect") }}<br /><br />
                            {{ $t("are_you_sure_you_want_to_make_the_payment") }}</p>
                        <div class="form-group d-flex justify-content-center">
                            <div class="ito-btn-small" style="margin: 0px 10px">{{ $t('cancel') }}</div>
                            <div class="ito-btn-small active" style="margin: 0px 10px" data-dismiss="modal" data-toggle="modal" data-target="#PopupPaymentFail">{{ $t('yes') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade payment-popup" id="PopupPaymentFail" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentFail" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 475px;">
                    <div class="modal-content box-shadow-main paymment-status">
                        <div class="close-popup" data-dismiss="modal"></div>
                        <h3 class="popup-title mb-20 fail">{{ $t('lisa_web_payment_unsuccessfully') }}</h3>
                        <img src="/themes/ito/images/payment-fail.png" width="87px">
                        <p>{{ $t("your_payment_has_failed") }}<br />
                            {{ $t("sure_payment_detail_correct") }}</p>
                        <div class="form-group d-flex justify-content-center">
                            <div class="ito-btn-small" style="margin: 0px 10px" data-dismiss="modal" data-toggle="modal" data-target="#PopupPaymentTransfer">{{ $t("cancel") }}Cancel
                            </div>
                            <div class="ito-btn-small active" style="margin: 0px 10px" data-dismiss="modal" data-toggle="modal" data-target="#PopupPaymentSuccess">{{ $t("yes") }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade payment-popup" id="PopupPaymentSuccess" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentSuccess" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 475px;">
                    <div class="modal-content box-shadow-main paymment-status">
                        <div class="close-popup" data-dismiss="modal"></div>
                        <h3 class="popup-title mb-20 success">{{ $t('lisa_web_payment_successfully') }}</h3>
                        <img src="/themes/ito/images/payment-fail.png" width="87px">
                        <p>{{ $t('thank_you') }}<br />
                            {{ $t('your_payment_has_been_processed_successfully') }}</p>
                    </div>
                </div>
            </div>
            <div class="modal fade payment-popup" id="PopupPaymentTransfer" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentTransfer" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 700px;">
                    <div class="modal-content box-shadow-main">
                        <div class="close-popup" data-dismiss="modal"></div>
                        <h3 class="popup-title mb-20">{{ $t('lisa_web_use_bank_transfer') }}</h3>
                        <p>{{ $t('lisa_web_payment_below_instruction') }}<br />
                            <b>{{ $t('lisa_web_account_info_after_transfer') }}</b><br />
                            {{ $t('username') }}: <b>demo_001</b><br />
                            {{ $t('lisa_web_renew_package') }} <b>iTO PRO 12 months</b><br />
                            Expected expired time: <b>19 May, 2022</b><br />
                            <b>Instruction to make money transfer:</b><br />
                            To upgrade, please make money transfer to iTO bank account according to the following
                            information:<br />
                            (1) Beneficiary name: <b>CÔNG TY CỔ PHẦN GIÁO DỤC ISMART</b><br />
                            (2) Bank: <b>Vietcombank</b><br />
                            (3) Account number: <b>87285789759872</b><br />
                            (4) Branch: <b>Sai Thanh</b><br />
                            (5) Total money: <b>150,000đ</b><br />
                            (6) Content: <b>iTO [Student ID] [Phone number]</b><br />
                            For example:<br />
                            Customer has <b>Student ID</b> demo_001, <b>Phone number</b> 09xxxxxx00 demanding to
                            register iTO1 package. Customer needs to enter the content of money transfer as follows:
                            <b>iTO1 demo_001 09xxxxxxx00</b><br /><br />

                            <b>Note:</b><br />
                            In the content of transfer, the information “Student ID” and “Phone number” are required for
                            the account upgrade process completed as soon as possible.<br />
                            This request is auto cancelled by iTO after 72 hours (02 working days, except Saturday and
                            Sunday) if you don't make money transfer to iTO bank account.
                        </p>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import axios from "axios";
import { soundClick } from '../../utils/utils'
import { getPackages, postPayment } from "../../models/payment";
import UpgradeNavTabs from "./UpgradeNavTabs.vue";
import SimpleSwiper from "../common/SimpleSwiper.vue"


export default {
    name: "UpgradeAccount",
    title: 'Upgrade Account',
    components: {
        UpgradeNavTabs,
        SimpleSwiper
    },
    data() {
        return {
            packages: [],
            gates: [],
            isLoading: true,
            product: '',
            package_select: 1,
            product_id: '',
            method: '',
            step: 1,
            applyCode: "",
            itemProduct: ""
        };
    },

    created() {
        this.$store.commit('setMenuActive', 'parent');

        this.fetch();
    },

    // watch: {
    //     'package_select': function(newVal, oldVal) {
    //         if(newVal != ''){
    //             this.screen = 2
    //         }
    //     },
    // },

    methods: {
        async fetch(page = 1) {
            const that = this;
            const lang = localStorage.getItem('lang') || 'vi';
            await axios.all([
                getPackages({
                    os: 'web',
                    lang: lang
                }),
            ]).then(axios.spread((package_response) => {
                that.isLoading = false;
                if (package_response.data.code != 0) {
                    return;
                }
                that.packages = package_response.data.results.packages || [];
                if (that.packages.length > 0) {
                    that.package_select = that.packages[0].id;
                }
                that.gates = package_response.data.results.gate || [];
            }));
        },
        gotoStep(step) {
            this.step = step;
        },
        handleSelect(item) {
            var data = this.packages.filter(x => x.id == item)
            this.product = data[0].products[0].product_id
            this.itemProduct = data[0].products[0]
        },
        Payment() {
            const that = this;

            that.$store.commit("setLoading", true);
            const formData = new FormData();
            formData.append('product_id', this.product);
            formData.append('voucher', 'xxx');
            formData.append('method', this.method);
            postPayment(formData).then((data) => {
                that.$store.commit("setLoading", false);
                if (data.data.code == 0) {
                    window.location.href = data.data.results.url;
                }
                else {
                    alert(data.data.results);
                }
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);
                alert(response.data.results);
            });
        },

        getSoundClick() {
            soundClick();
        },

    }
}
</script>

<style scoped>
[type="radio"]:not(:checked),
[type="radio"]:checked {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.slect-method [type="radio"]+label:before,
.slect-method [type="radio"]+label:after {
    display: none;
}

.slect-method [type=radio]:checked+label.payment-method-item {
    opacity: 1;
    border: 2px solid #40C0F6;
}

.package-content-1 img {
    filter: grayscale(1);
}

.select-upgrade-type [type=radio]:checked+label.package .package-content-1 img {
    filter: grayscale(0);
}

.slect-method label {
    display: block;
    /*width: 100%;*/
    /*height: 100%;*/
}

.slect-name {
    font-size: 14px;
    font-weight: 400;
}

.slect-show {
    display: flex;
}

.slect-hide {
    display: none;
}

.slect-product [type=radio]:checked+label.slect-package {
    color: #FFDB6F;
    background: #e98437;
}

.test {
    color: #FFDB6F !important;
    background: #e98437 !important;
}

.payment-method-item {
    padding: 0;
    min-height: 120px;
    background: #FFFFFF;
    border: 2px solid #CCD2E3;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.07);
    border-radius: 8px;
}

.img-gate-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 25px 10px 25px;
}

.img-gate-box img {
    width: 100%;
    height: 45px !important;
    object-fit: contain;
}

.payment-method-text {
    font-size: 14px;
    line-height: 19px;
    color: #000000;
    margin-top: 0;
    justify-content: center;
    align-items: start;
}

.slect-package {
    height: 65px;
    padding: 0 30px;
    align-items: center;
    font-weight: 700;
    font-size: 20px;
    color: #FFFFFF;
    background: #C1C1C1;
    margin-bottom: 12px;
    cursor: pointer;
    border-radius: 8px;
}

#upgrade-detail .title {
    font-weight: 700;
    padding-bottom: 12px;
}

#upgrade-detail .card-title {
    height: 44px;
}

/* #upgrade-detail{
        width: 940px;
        display: flex;
        justify-content: center;
    } */
/* .container{
        width: 940px;
    } */

/* .lisa-icon-payment-check-1{
        min-width: unset;
        background-color: red;
    } */


.container {
    width: 942px;
    padding: 0;
}

.package {
    display: flex;
    padding: 0;
}


.list-package {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    /* flex-wrap: wrap; */
    overflow-x: auto;
}

::-webkit-scrollbar {
    display: none;
}



.desc-box-item img {
    margin-right: 12px;
    display: flex;
    align-self: flex-start;
}

.desc-box {
    margin-bottom: 0 !important;
}

.btn-back {
    font-size: 20px;
    height: 45px;
    margin-right: 20px;
    line-height: 45px;
    /* display: flex; */
    align-items: center;
    width: fit-content;
    line-height: 32px;
}

.btn-apply_code {
    color: #FFFFFF;
    text-align: center;
    font-weight: 700;
    padding: 12px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #A3A3A3;
    border-radius: 8px;
}
</style>